module.exports = __webpack_public_path__ + "static/markus-spiske-N_TFAu9gtf0-unsplash-12f445e6900d98de2a5aa2def29562bc.jpg";